import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from '../components/auth/ProtectedRoute';

// 导入认证页面组件
import LoginPage from '../pages/auth/LoginPage';
import ForgotPasswordPage from '../pages/auth/ForgotPasswordPage';
import ResetPasswordPage from '../pages/auth/ResetPasswordPage';

// 导入用户页面组件
import ProfilePage from '../pages/user/ProfilePage';
import HistoryPage from '../pages/user/HistoryPage';

// 导入应用页面组件
import HomePage from '../pages/HomePage';
import SearchPage from '../pages/SearchPage';
import EpisodesPage from '../pages/EpisodesPage';
import ImagesPage from '../pages/ImagesPage';
import SettingsPage from '../pages/SettingsPage';
import CategorizedLibraryPage from '../pages/CategorizedLibraryPage';
import SearchBasedLibraryPage from '../pages/SearchBasedLibraryPage';
import FavoritesPage from '../pages/FavoritesPage';
import OperationLogTestPage from '../pages/OperationLogTestPage';

// 404页面组件
const NotFoundPage: React.FC = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="text-center">
      <h1 className="text-4xl font-bold text-gray-800 mb-4">404</h1>
      <p className="text-gray-600 mb-4">页面未找到</p>
      <a href="/" className="text-blue-600 hover:text-blue-500">
        返回首页
      </a>
    </div>
  </div>
);

/**
 * 应用路由组件
 */
const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* 主要功能路由 - 需要登录 */}
      <Route 
        path="/" 
        element={
          <ProtectedRoute requireAuth={true}>
            <HomePage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/search" 
        element={
          <ProtectedRoute requireAuth={true}>
            <SearchPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/episodes/:showId" 
        element={
          <ProtectedRoute requireAuth={true}>
            <EpisodesPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/images/:episodeId" 
        element={
          <ProtectedRoute requireAuth={true}>
            <ImagesPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/sample-images" 
        element={
          <ProtectedRoute requireAuth={true}>
            <ImagesPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/images-range/:startId/:endId" 
        element={
          <ProtectedRoute requireAuth={true}>
            <ImagesPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/local-library" 
        element={
          <ProtectedRoute requireAuth={true}>
            <ImagesPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/categorized-library" 
        element={
          <ProtectedRoute requireAuth={true}>
            <CategorizedLibraryPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/search-based-library" 
        element={
          <ProtectedRoute requireAuth={true}>
            <SearchBasedLibraryPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/operation-log-test" 
        element={
          <ProtectedRoute requireAuth={true}>
            <OperationLogTestPage />
          </ProtectedRoute>
        } 
      />
      
      {/* 认证路由 - 仅未登录用户可访问 */}
      <Route 
        path="/login" 
        element={
          <ProtectedRoute requireAuth={false}>
            <LoginPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/forgot-password" 
        element={
          <ProtectedRoute requireAuth={false}>
            <ForgotPasswordPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/reset-password" 
        element={
          <ProtectedRoute requireAuth={false}>
            <ResetPasswordPage />
          </ProtectedRoute>
        } 
      />
      
      {/* 用户路由 - 需要登录 */}
      <Route 
        path="/profile" 
        element={
          <ProtectedRoute requireAuth={true}>
            <ProfilePage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/settings" 
        element={
          <ProtectedRoute requireAuth={true}>
            <SettingsPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/favorites" 
        element={
          <ProtectedRoute requireAuth={true}>
            <FavoritesPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/history" 
        element={
          <ProtectedRoute requireAuth={true}>
            <SearchBasedLibraryPage />
          </ProtectedRoute>
        } 
      />
      
      {/* 404路由 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;